import { gql } from '@apollo/client';

export const GET_TASKS_WITH_FIELDS = gql`
  query GetTasksWithFields {
    vm {
      tasks(status: "active", programIds: [], activityIds: []) {
        taskId
        title
        description
        cake {
          cakeId
          title
          cakeType
        }
        adminOnly
        isEventTask
        isRefereeCheckTask
        managerCompleted
        taskItems {
          ... on VOLUNTEER_TaskItemFieldType {
            taskItemId
            dateRemoved
            field {
              __typename
              taskFieldId
              name
              dateDeactivated
              ... on VOLUNTEER_DropdownTaskFieldType {
                dropdownOptions {
                  dropdownFieldOptionId
                  name
                }
              }
              ... on VOLUNTEER_MultipleChoiceTaskFieldType {
                multipleChoiceOptions {
                  multipleChoiceFieldOptionId
                  name
                }
              }
              ... on VOLUNTEER_CheckboxTaskFieldType {
                checkboxOptions {
                  checkboxFieldOptionId
                  name
                }
              }
              ... on VOLUNTEER_QuizTaskFieldType {
                quizTaskFieldOptions {
                  quizTaskFieldOptionId
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;
